import React from 'react';
import { useSelector } from 'react-redux';
import { css } from '@emotion/core';
import Typography from '@material-ui/core/Typography';
import useIsContestUgcModule from 'client/game_photoContest/hooks/useIsContestUgcModule';

import VerifyStatusLabel from 'client/components/verify/VerifyStatusLabel';
import UgcVoteInfo from 'client/components/Result/EntriesInfo/customResult/UgcVoteInfo';
import CommentSettings from 'components/Comment/CommentSettings';
import AsceptRatioContainer from 'components/Comment/AsceptRatioContainer';
import i18n from 'i18next';
function ResultComment({
    resultCreatedAt,
    componentStyle,
    validStatus,
    resultInfo: { mediaLibraryUuid, media } = {}
}) {
    const isContestUgcModule = useIsContestUgcModule();
    const { enableFixedAspectRatio } = useSelector(s => s.settingGame);
    const isFixed = enableFixedAspectRatio === 1;
    const { settingOptions } = useSelector(s => s.gameState);
    return (
        <div css={cardContainerStyle}>
            <div css={headerStyle}>
                <Typography variant="body2" css={dateStyle(componentStyle?.titleColor)}>
                    {i18n.t('label.date.value', { date: resultCreatedAt })}
                </Typography>
                {isContestUgcModule ? (
                    <UgcVoteInfo
                        mediaLibraryUUID={mediaLibraryUuid}
                        componentStyle={componentStyle}
                    />
                ) : (
                    <VerifyStatusLabel status={validStatus} />
                )}
            </div>
            <div css={contentStyle}>
                {media?.map(({ result, promotionOptionUuid: commentBgUUID }) => {
                    const settings = settingOptions.find(({ uuid }) => uuid === commentBgUUID);
                    return isFixed ? (
                        <AsceptRatioContainer aspectRatio={7 / 10}>
                            <CommentSettings
                                settings={settings}
                                result={result}
                                isFixed={isFixed}
                                isResult={true}
                            />
                        </AsceptRatioContainer>
                    ) : (
                        <CommentSettings
                            settings={settings}
                            result={result}
                            isFixed={isFixed}
                            isResult={true}
                        />
                    );
                })}
            </div>
        </div>
    );
}

export default ResultComment;

const cardContainerStyle = css`
    padding: 8px 0px;
`;

const headerStyle = css`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
`;

const dateStyle = titleColor => css`
    color: ${titleColor};
    font-size: 14px;
`;

const contentStyle = css`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;
